var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 11,
    height: 11,
    rx: 1,
    stroke: "#3C4469",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 20,
    width: 11,
    height: 11,
    rx: 1,
    stroke: "#3C4469",
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 3,
    width: 11,
    height: 11,
    rx: 1,
    stroke: "#3C4469",
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 11,
    height: 11,
    rx: 1,
    stroke: "#3C4469",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.72a0def014606f54cc8f5570e176af1f.svg";
export { ForwardRef as ReactComponent };